var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:[
        _vm.category && _vm.category.fa ? JSON.parse(_vm.category.fa).icon : 'fak fa-trattore-stradale'
    ]})
}
var staticRenderFns = []

export { render, staticRenderFns }